import axios from 'axios';
import CryptoHelper from 'utils/cryptHelper';

// Centralized encryption/decryption helpers using CryptoHelper (no cryptr)
export function encryptJSON(payload) {
	return CryptoHelper.encryptJSON(payload);
}

export function decryptJSON(cipherOrJson) {
	return CryptoHelper.decryptJSON(cipherOrJson);
}

export async function login(username, password) {
	let data = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}login`,
			data: { username, password },
			headers: { 
				'content-type': 'application/json',
				'authorization': `Bearer ${process.env.REACT_APP_LAB_API_SECREY_KEY}`
			}
		});

		data = response;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return data;
}

export async function user(userID) {
	let userData = null;
	console.log('id', userID)
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}login/user`,
			data: { userID },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		userData = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return userData;
}

export async function updatePasssword(userID, password) {
	let updatePass = null;
	try{
		const response = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}login/updatepassword`,
			data: { userID, password },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		updatePass = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return updatePass;
}